import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import '../App.css';
import CancelModalComponent from '../popUpModals/CancelModalComponent';

const mapStateToProps = (state) => {
    return {
        userStatus: state.lognReducer
    }
}

class UpdateUser extends React.Component {
    constructor() {
        super();
        this.state = {
            show: false,
            usersList: [],
            reDirect: '',
            email: '',
            userRole: '',
        }
    }

    componentDidMount = async () => {
        if (this.props.userStatus.userName !== "") {
            this.setState({
                ...this.state,
                email: this.props.userStatus.emailId,
                userRole: this.props.userStatus.userRole,
            }, () => {
                this.getAllUsers();
            })

        } else {
            this.setState({
                reDirect: '/',
            })
        }
    }


    getAllUsers() {
        if (this.props.values.UsersList !== undefined && this.props.values.UsersList !== null && this.props.values.UsersList.length > 0) {
            this.setState({
                ...this.state,
                usersList: this.props.values.UsersList,
            })
        } else {
            this.setState({
                ...this.state,
                totalItems: 0
            })
        }
    }

    onCancelChanges() {
        this.setState({
            reDirect: './userSummary'
        })
    }

    toContinue(event) {
        event.preventDefault();
        this.props.nextStep();
    }


    toBack(event) {
        event.preventDefault();
        this.setState({
            reDirect: './userSummary'
        })
    }

    showModal = (event) => {
        event.preventDefault();
        this.setState({
            ...this.state,
            show: true
        })
    }

    onCloseModal() {
        this.setState({
            show: false
        })
    }

    render() {
        if (this.state.reDirect) {
            return <Redirect
                to={{
                    pathname: this.state.reDirect
                }} />
        }
        return (
            <section style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <div className="container mt-2 ">
                    <h4>Update Selected User</h4>
                    <div className="table-responsive dashboard ">
                        <table className="table table-bordered table-condensed table-striped table-hover table-sm"
                            id="table-dashboard">
                            <thead className="color">
                                <tr style={{ borderStyle: 'hidden' }}>
                                    <th></th>
                                    <th > Name </th>
                                    <th >Login Id</th>
                                    <th >User Type</th>
                                    <th >Source</th>
                                </tr>
                            </thead>
                            <tbody style={{ borderStyle: 'hidden' }}  >
                                {this.state.usersList.map((user, index) => (
                                    <tr key={index}>
                                        <td align="center">
                                            <input type="checkbox" name="user"
                                                defaultChecked disabled
                                            ></input>
                                        </td>
                                        <td>{user.firstName}{user.lastName}</td>
                                        <td>{user.mailId}</td>
                                        <td>Member</td>
                                        <td>Azure Active Directory</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <main>
                        <div className="row mb-2 mt-2">
                            <div className="col-md-6 mr-auto text-left">
                                <button className="btn  btn-primary" onClick={(event) => this.toBack(event)} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Back</button>
                                <button className="btn  btn-primary" onClick={(event) => this.toContinue(event)} style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Continue</button>
                                <button type="button" onClick={this.showModal} className="btn  btn-primary  " style={{ marginRight: '1%', backgroundColor: '#ADD8E6', color: '#000', borderColor: '#000' }} >Cancel  </button>
                            </div>
                        </div >
                        <CancelModalComponent show={this.state.show} hideModal={() => this.onCloseModal()} cancelChanges={() => this.onCancelChanges()}></CancelModalComponent>
                    </main>
                </div >
                <ToastContainer style={{ marginTop: '7%' }} />
            </section >
        )
    }

}
export default connect(mapStateToProps)(UpdateUser);